class PupmdGutStoryVideoV2 extends HTMLElement {
  /** @type {AbortController | null} */
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    const playButton = this.querySelector('[data-video-play]');
    const template = this.querySelector('[data-video-template]');

    if (!(playButton instanceof HTMLButtonElement)) return;
    if (!(template instanceof HTMLTemplateElement)) return;

    playButton.addEventListener(
      'click',
      () => {
        this.#activate(playButton, template);
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#abort = null;
  }

  /** @param {HTMLButtonElement} playButton @param {HTMLTemplateElement} template */
  #activate(playButton, template) {
    if (this.hasAttribute('data-video-loaded')) return;

    const content = template.content.firstElementChild?.cloneNode(true);
    if (!content || !(content instanceof HTMLElement)) return;

    this.setAttribute('data-video-loaded', 'true');

    const previewElement = this.querySelector('[data-video-preview]');
    const innerElement = this.querySelector('[data-video-inner]');

    if (previewElement instanceof HTMLElement) {
      previewElement.classList.add('is-hidden');
    }
    playButton.remove();

    if (innerElement instanceof HTMLElement) {
      innerElement.classList.add('is-playing');
      innerElement.appendChild(content);
    }

    if (content instanceof HTMLVideoElement) {
      content.play().catch(() => {});
      return;
    }

    if (content instanceof HTMLIFrameElement) {
      content.focus();
    }
  }
}

if (!customElements.get('pupmd-gut-story-video-v2')) {
  customElements.define('pupmd-gut-story-video-v2', PupmdGutStoryVideoV2);
}
